module.exports = __webpack_public_path__ + "23c63b7b1f54cc337595872289ffd35f.pdf";